import { FAKE, REAL, registerDependency } from 'components/shared/dependency-injection/dependency-injection.js'

export interface StorefrontAPITokenResponse {
  token: string
}

export interface StorefrontAPIErrorResponse {
  api_error_code: number
  api_error_code_description: string
  description: string
  message: string
}

export type StorefrontApiResponse<T> = Promise<T | StorefrontAPIErrorResponse>

export abstract class GenericStorefrontAPIRequest {
  endpointUrl: string
  method: 'GET' | 'POST' = 'GET'
  headers: HeadersInit = { Accept: 'application/json', 'Content-Type': 'application/json' }
  controller: AbortController = new AbortController()

  constructor(endpointUrl: string) {
    this.endpointUrl = endpointUrl
  }
}

export class AuthenticatedStorefrontAPIRequest extends GenericStorefrontAPIRequest {
  tokenEndpoint: string

  constructor(tokenEndpoint: string, endpointUrl: string) {
    super(endpointUrl)
    this.tokenEndpoint = tokenEndpoint
  }
}

export abstract class AuthenticatedStorefrontAPIPOSTRequest extends AuthenticatedStorefrontAPIRequest {
  body: string = ''
  override method = 'POST' as const
}

export class GetTokenRequest extends GenericStorefrontAPIRequest { }

export interface EcommerceApiTokenAPI {
  getToken(request: GetTokenRequest): StorefrontApiResponse<StorefrontAPITokenResponse>
}

export class FakeEcommerceApiTokenAPI implements EcommerceApiTokenAPI {
  tokenRequests: GetTokenRequest[] = []
  tokenData: StorefrontAPITokenResponse = { token: 'fake-token' }

  getToken(request: GetTokenRequest) {
    this.tokenRequests.push(request)
    return Promise.resolve(this.tokenData)
  }
}

export class RealEcommerceApiTokenAPI implements EcommerceApiTokenAPI {
  async getToken(request: GetTokenRequest): Promise<StorefrontAPITokenResponse> {
    const response = await fetch(request.endpointUrl, {
      method: request.method,
      headers: request.headers,
    })
    return response.json()
  }
}

export let ecommerceApiTokenApi!: EcommerceApiTokenAPI
registerDependency({
  [REAL]: () => ecommerceApiTokenApi = new RealEcommerceApiTokenAPI(),
  [FAKE]: () => ecommerceApiTokenApi = new FakeEcommerceApiTokenAPI(),
})
